"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActiveProvider = _interopRequireDefault(require("../providers/ActiveProvider"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _UIClickable = _interopRequireDefault(require("./UIClickable"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _Styles = require("../utils/Styles");

var _decorators = require("../utils/propTypes/decorators");

var _Color = require("../core/Color");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  border-radius: 20px;\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  box-shadow: 0 5px 20px 0 rgba(12, 73, 84, 0.2);\n  display: inline-flex;\n  font-size: ", ";\n  line-height: normal;\n  min-height: ", ";\n  padding: 0 10px;\n  position: relative;\n  ", ";\n  user-select: none;\n  vertical-align: ", ";\n\n  /* patch for IE min-height flexbug:\n   * https://github.com/philipwalton/flexbugs/blob/master/README.md#flexbug-3\n   * */\n  &::after {\n    content: '';\n    display: block;\n    height: ", ";\n    margin-left: -1px;\n    width: 1px;\n  }\n\n  &::before {\n    background-color: ", ";\n    border-radius: inherit;\n    bottom: 0;\n    content: '';\n    display: ", ";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FAB_HEIGHT = '50px';
var Fab = (0, _styledComponents.default)(function (props) {
  var __active = props.active,
      __hovered = props.hovered,
      __pointySide = props.pointySide,
      rest = (0, _objectWithoutProperties2.default)(props, ["active", "hovered", "pointySide"]);
  return _react.default.createElement(_UIClickable.default, rest);
}).withConfig({
  displayName: "UIFloatingActionButton__Fab",
  componentId: "xrvds8-0"
})(_templateObject(), function (props) {
  return props.pointySide === 'bottom-left' && _sizes.BUTTON_RADIUS;
}, function (props) {
  return props.pointySide === 'bottom-right' && _sizes.BUTTON_RADIUS;
}, _sizes.BUTTON_DEFAULT_FONT_SIZE, FAB_HEIGHT, (0, _Styles.setUiTransition)('background'), _misc.INPUT_VERTICAL_ALIGNMENT, FAB_HEIGHT, (0, _Color.rgba)(_colors.MONOLITH, 0.1), function (props) {
  return props.active ? 'block' : 'none';
});

var UIFloatingActionButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIFloatingActionButton, _PureComponent);

  function UIFloatingActionButton() {
    (0, _classCallCheck2.default)(this, UIFloatingActionButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIFloatingActionButton).apply(this, arguments));
  }

  (0, _createClass2.default)(UIFloatingActionButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        return _react.default.createElement(_ActiveProvider.default, _this.props, function (activeProviderProps) {
          return _react.default.createElement(Fab, (0, _extends2.default)({}, _this.props, hoverProviderProps, activeProviderProps));
        });
      });
    }
  }]);
  return UIFloatingActionButton;
}(_react.PureComponent);

UIFloatingActionButton.propTypes = {
  children: _react.PropTypes.node,
  hovered: (0, _decorators.hidden)(_react.PropTypes.bool),
  pointySide: _react.PropTypes.oneOf(['bottom-left', 'bottom-right'])
};
UIFloatingActionButton.defaultProps = {
  pointySide: 'bottom-left'
};
UIFloatingActionButton.displayName = 'UIFloatingActionButton';
var _default = UIFloatingActionButton;
exports.default = _default;
module.exports = exports.default;